import App from 'App';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { captureQaRefusalTrigger } from 'utils/qaRefusal';
import './index.css';

// Capture the DEV-only ?qaRefusal= token before navigation rewrites the URL and
// drops the query string (see utils/qaRefusal.web.ts).
captureQaRefusalTrigger(window.location.search);

// Render the root component into the root element in the HTML
ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
